import React, { useEffect, useState } from 'react';
import { Tabs, Tab, Box, Typography, IconButton, Paper, InputBase } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { styled } from '@mui/material/styles';
import UserHeader from '../../component/reusable/UserHeader';
import Cards from '../../component/reusable/Cards';
import AllBomOrderTable from '../../component/bomComps/AllBomOrderTable';
import BomOrderCard from '../../component/bomComps/BomOrderCard';
import BomOrderTab from '../../component/bomComps/BomOrderTab';
import { exportDataExcel, fomateDate } from '../../utils/fomateDate';
import { deletewizardOrderThunk, exportwizardOrderThunk, getAllwizardOrderThunk, getwizardOrderStatisticsThunk, setwizardOrderFromDate, setwizardOrderPage, setwizardOrderSearch, setwizardOrderSelectedTab, setwizardOrderToDate } from '../../redux/wizardOrderSlice';
import AllWizardOrderTable from '../../component/wizardComps/AllWizardOrderTable';
import BomOrderFilter from '../../component/bomComps/BomOrderFilter';

const SearchInput = styled(Paper)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    borderRadius: '8px',
    boxShadow: 'none',
    border: `1px solid ${theme.palette.divider}`,
    width: '320px',
    margin: "20px 0px",
    fontFamily: `'Public Sans', sans-serif`,
}));

function WizardOrders() {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [allStatus, setAllStatus] = useState('')
    const [limit, setLimit] = useState(25)
    const [sortBy, setSortyBy] = useState('createdAt');
    const [order, setOrder] = useState('dsc')
    const [selectedId, setSelectedId] = useState(null)
    const [isModalOpen, setIsModalOpen] = useState(false);

    const deleteCategory = (password) => {
        dispatch(deletewizardOrderThunk({ id: selectedId, password }))
        setIsModalOpen(false);

    }


    //delete modal open
    const handleDeleteClick = (id) => {
        setIsModalOpen(true);
        setSelectedId(id)
    };


    const handleChange = (event, newValue) => {
        dispatch(setwizardOrderSelectedTab(newValue))
        setAllStatus('')
        dispatch(setwizardOrderPage(1))
        dispatch(setwizardOrderSearch(''))
        dispatch(setwizardOrderFromDate(''))
        dispatch(setwizardOrderToDate(''))
    };

    const { wizard, loading, refresh, page, search, fromDate, toDate, exportLoading, selectedTab, orderStatistics } = useSelector((state) => state.wizardOrder);
    const wizardData = wizard?.data
    const totalPages = wizard?.totalPages
    const totalItems = wizard?.totalItems
    const itemsPerPage = wizard?.limit

    console.log(wizardData);

    const start = (page - 1) * limit + 1;
    const end =
        totalPages === page
            ? totalItems
            : (page - 1) * limit + limit;

    const status = selectedTab === 0 ? allStatus : selectedTab === 1 ? 'NEW' : selectedTab === 2 ? 'DELIVERED' : "CANCELLED"

    //    console.log(wizard);

    useEffect(() => {
        dispatch(getAllwizardOrderThunk(`?search=${search}&page=${page}&status=${status}&fromDate=${fromDate}&toDate=${toDate}&sortBy=${sortBy}&order=${order}&orderType=WIZARD`));
    }, [page, search, status, limit, refresh, sortBy, order, fromDate, toDate]);


    const handleOpenMenu = (sort) => {
        setSortyBy(sort)
        setOrder((prevOrder) => (prevOrder === 'asc' ? 'desc' : 'asc'));
    };

    const exportwizardenq = async () => {
        const status = await dispatch(exportwizardOrderThunk(`?limit=${100000}&orderType=WIZARD`))
        if (status?.payload?.success === true) {
            console.log("status", status?.payload?.data);

            const exportOrderData = status?.payload?.data
            const exportdata = exportOrderData?.map((item) => ({
                'id': item?._id || '-',
                'Name': item?.user?.fullName || '-',
                'Company': item?.user?.companyName || '-',

                'products': item?.productCount + 'products',
                'Total': item?.total || '-',
                'Status': item?.status || '-',
                'CreatedAt': fomateDate(item?.createdAt),
            }))
            // console.log("expo", exportdata);

            exportDataExcel(exportdata, "wizard")
        }
    }



    useEffect(() => {
        dispatch(getwizardOrderStatisticsThunk(`?orderType=WIZARD`))
    }, [])

    return (
        <>
            <UserHeader
                index="wizard Orders"
                root="Dashboard"
                exportData={exportwizardenq}
                exportLoading={exportLoading}
                hideadd={'hide'}
            />

            <BomOrderCard orderStatistics={orderStatistics} />

            <Box>

                <BomOrderTab handleChange={handleChange} selectedTab={selectedTab} />
                <BomOrderFilter
                    setAllStatus={setAllStatus}
                    search={search} selectedTab={selectedTab}
                    setOrderFromDate={setwizardOrderFromDate}
                    setOrderToDate={setwizardOrderToDate}
                    setSearch={setwizardOrderSearch}
                />

                <Box >
                    {
                        loading ?
                            <div style={{ display: 'flex', justifyContent: 'center' }}>Loading...</div>
                            :
                            <>
                                {wizardData?.length > 0 ?
                                    <Typography>
                                        <AllBomOrderTable
                                            bomData={wizardData}
                                            page={page}
                                            setPage={setwizardOrderPage}
                                            itemsPerPage={itemsPerPage}
                                            totalItems={totalItems}
                                            totalPages={totalPages}
                                            start={start}
                                            end={end}
                                            handleOpenMenu={handleOpenMenu}
                                            selectedTab={selectedTab}
                                            handleDeleteClick={handleDeleteClick}
                                            deleteCategory={deleteCategory}
                                            setIsModalOpen={setIsModalOpen}
                                            isModalOpen={isModalOpen}
                                            path={'/wizard/wizardOrderDetails'}
                                        />
                                    </Typography>
                                    :
                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        No Data found
                                    </div>
                                }
                            </>
                    }
                </Box>

            </Box>
        </>
    );
}

export default WizardOrders;
